import { render, staticRenderFns } from "./ChooseInitializeCommunity.vue?vue&type=template&id=6cfe4d76&scoped=true"
import script from "./ChooseInitializeCommunity.vue?vue&type=script&lang=js"
export * from "./ChooseInitializeCommunity.vue?vue&type=script&lang=js"
import style0 from "./ChooseInitializeCommunity.vue?vue&type=style&index=0&id=6cfe4d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe4d76",
  null
  
)

export default component.exports